// extracted by mini-css-extract-plugin
export default {"container":"Ng","overlay":"Og","videoOverlay":"Pg","withHeader":"Qg","header":"Rg","close":"Sg","content":"Tg"};